export function toCredits(value) {
  if (typeof value === "number") {
    return Number.isFinite(value) ? Math.trunc(value) : 0;
  }
  const parsed = parseInt(value, 10);
  return Number.isFinite(parsed) ? parsed : 0;
}

export function adjustCredits(current, ...deltas) {
  return deltas.reduce((total, delta) => total + toCredits(delta), toCredits(current));
}
